import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';
import { GlobalService, AppsService } from '@/service';

import { APP_LIST_TYPE } from '@/service/apps/type/appList.d';
import { TypeParams } from '@/service/global/type/appType';
import { TeamAppTypeListReplyItem } from '@/service/global/type/teamType';
import { AppListParams } from '@/service/apps/type.d';

type GlobalType = {
  appId: string;
  appType: TypeParams[] | undefined;
  teamType: TeamAppTypeListReplyItem[] | undefined;
  appInfo: APP_LIST_TYPE;
};

//获取APP type 信息
export const fetchAppTypesAsync = createAsyncThunk('post/appType', async () => {
  const response = await GlobalService.getAppType();
  if (response.code) {
    return null;
  }
  return response;
});

// 获取团队 Type 信息
export const fetchTeamTypesAsync = createAsyncThunk('post/teamType', async () => {
  const response = await GlobalService.getTeamAppType();
  if (response.code) {
    return null;
  }
  return response;
});

//获取APPInfo信息
export const fetchAppInfoAsync = createAsyncThunk('post/appInfo', async (params: AppListParams) => {
  const response = await AppsService.fetchAppDetail(params);
  if (response.code) {
    return null;
  }
  return response;
});

const initialState: GlobalType = {
  appId: '0',
  appType: [],
  teamType: [],
  appInfo: {},
};

const global = createSlice({
  name: 'global',
  initialState,
  reducers: {
    setAppId(state, action: PayloadAction<APP_LIST_TYPE>) {
      return {
        ...state,
        appId: action.payload.id!,
      };
    },
  },
  extraReducers(builder) {
    builder.addCase(fetchAppTypesAsync.fulfilled, (state, action) => {
      state.appType = action.payload?.data;
    });
    builder.addCase(fetchTeamTypesAsync.fulfilled, (state, action) => {
      state.teamType = action.payload?.data;
    });
    builder.addCase(fetchAppInfoAsync.pending, (state, action) => {
      state.appInfo = {};
    }),
      builder.addCase(fetchAppInfoAsync.fulfilled, (state, action) => {
        state.appInfo = action.payload?.data!;
      });
    builder.addCase(fetchAppInfoAsync.rejected, (state, action) => {
      console.log('出错了~ 可以卡页面  在APPINFO出的错');
    });
  },
});

export const actions = global.actions;
export const reducer = global.reducer;
